<template>
  <div class="grid">
    <div class="col-12">
      <div class="card">
        <div class="flex justify-content-between align-items-center mb-4">
          <h5 class="m-0">Gestión de Promociones Dinámicas</h5>
          <Button label="Nueva Promoción" icon="pi pi-plus" class="p-button-success" @click="irACrear" />
        </div>

        <DataTable :value="promociones" :paginator="true" class="p-datatable-gridlines" :rows="10" dataKey="id" :loading="loading" emptyMessage="No se encontraron promociones.">
          <Column field="nombre" header="Nombre de Campaña" :sortable="true"></Column>
          
          <Column field="dia_semana" header="Día de la Semana" :sortable="true">
            <template #body="slotProps">
              <span class="p-tag p-tag-info">{{ obtenerDia(slotProps.data.dia_semana) }}</span>
            </template>
          </Column>

          <Column header="Vigencia">
            <template #body="slotProps">
              <small>
                <b>Inicio:</b> {{ slotProps.data.fecha_inicio || 'Siempre' }} <br/>
                <b>Fin:</b> {{ slotProps.data.fecha_fin || 'Sin límite' }}
              </small>
            </template>
          </Column>

          <Column header="Canales Válidos">
            <template #body="slotProps">
              <span v-for="(canal, idx) in obtenerCanalesPermitidos(slotProps.data.canales_id)" :key="idx" :class="'p-badge p-badge-' + canal.color + ' mr-1'">
                {{ canal.nombre }}
              </span>
            </template>
          </Column>

          <Column field="estado" header="Estado" :sortable="true">
            <template #body="slotProps">
              <span :class="'p-badge ' + (slotProps.data.estado ? 'p-badge-success' : 'p-badge-danger')">
                {{ slotProps.data.estado ? 'ACTIVO' : 'INACTIVO' }}
              </span>
            </template>
          </Column>

          <Column header="Acciones" :exportable="false" style="min-width:8rem">
            <template #body="slotProps">
              <Button icon="pi pi-pencil" class="p-button-rounded p-button-warning mr-2" @click="irAEditar(slotProps.data)" v-tooltip.top="'Editar'" />
              <Button icon="pi pi-trash" class="p-button-rounded p-button-danger" @click="confirmarEliminar(slotProps.data)" v-tooltip.top="'Eliminar'" />
            </template>
          </Column>
        </DataTable>
      </div>
    </div>

    <!-- Dialogo de confirmación de eliminación -->
    <Dialog v-model:visible="deleteDialog" :style="{width: '450px'}" header="Confirmar Eliminación" :modal="true">
      <div class="flex align-items-center justify-content-center">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span v-if="promocionSeleccionada">¿Estás seguro de que deseas eliminar la promoción <b>{{ promocionSeleccionada.nombre }}</b>?</span>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteDialog = false" />
        <Button label="Sí, Eliminar" icon="pi pi-check" class="p-button-danger" @click="eliminarPromocion" />
      </template>
    </Dialog>
    
    <Toast />
  </div>
</template>

<script>
import PromotionService from '@/service/PromotionService';
import CanalVentaService from '@/service/CanalVentaService';

export default {
  data() {
    return {
      promociones: [],
      loading: true,
      deleteDialog: false,
      promocionSeleccionada: null,
      dias: {
        1: 'Lunes', 2: 'Martes', 3: 'Miércoles', 4: 'Jueves', 5: 'Viernes', 6: 'Sábado', 7: 'Domingo', null: 'Todos los días'
      },
      canalesVenta: []
    };
  },
  created() {
    this.promotionService = new PromotionService();
    this.canalVentaService = new CanalVentaService();
  },
  mounted() {
    this.cargarCanalesVenta();
    this.cargarPromociones();
  },
  methods: {
    cargarPromociones() {
      this.loading = true;
      this.promotionService.getPromotions().then(response => {
        this.promociones = response.data || response || [];
      }).catch(() => {
        this.$toast.add({severity:'error', summary: 'Error', detail: 'No se pudieron cargar las promociones', life: 3000});
      }).finally(() => {
        this.loading = false;
      });
    },
    obtenerDia(numero) {
      return this.dias[numero] || 'Desconocido';
    },
    cargarCanalesVenta() {
      // Método para cargar la lista maestra de canales
      this.canalVentaService.getCanalVentaSelect().then(response => {
        this.canalesVenta = response.canales_venta || response.canalventa || response.data || [];
      }).catch(() => {
        console.error('Error al cargar canales de venta');
      });
    },
    obtenerCanalesPermitidos(canales_id) {
      // Mapea los IDs de los canales a sus nombres reales con colores para badges
      if (!canales_id || canales_id.length === 0) return [{nombre: 'Todos', color: 'info'}];
      return canales_id.map(id => {
        const canal = this.canalesVenta.find(c => c.id === id);
        return {
          nombre: canal ? canal.nombre : 'Desconocido',
          color: canal && canal.nombre.toLowerCase().includes('whatsapp') ? 'success' : (canal && canal.nombre.toLowerCase().includes('local') ? 'primary' : 'warning')
        };
      });
    },
    irACrear() {
      this.$router.push({ name: 'promocion_crear' });
    },
    irAEditar(promocion) {
      this.$router.push({ name: 'promocion_editar', params: { id: promocion.id } });
    },
    confirmarEliminar(promocion) {
      this.promocionSeleccionada = promocion;
      this.deleteDialog = true;
    },
    eliminarPromocion() {
      this.promotionService.deletePromotion(this.promocionSeleccionada.id).then(() => {
        this.$toast.add({severity:'success', summary: 'Éxito', detail: 'Promoción eliminada', life: 3000});
        this.cargarPromociones();
      }).catch(() => {
        this.$toast.add({severity:'error', summary: 'Error', detail: 'No se pudo eliminar', life: 3000});
      }).finally(() => {
        this.deleteDialog = false;
        this.promocionSeleccionada = null;
      });
    }
  }
}
</script>
